import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLinkedInSuggestions,
  updateLinkedin,
} from "../../../redux/actions/certificateVerification";
import Slider from "react-slick";
import { FidgetSpinner } from "react-loader-spinner";
import { SET_USER_LINKEDIN_URL } from "../../../redux/actions/types";
import { toast } from "react-toastify";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";

const LinkedInSuggestions = ({ linkedinProfiles, setLinkedinProfiles }) => {
  const dispatch = useDispatch();
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  const [activeIndex, setActiveIndex] = useState(-1);
  const [newLinkedinUrl, setNewLinkedinUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const settings = {
    dots: false,
    slidesToShow: linkedinProfiles?.length === 1 ? 1 : 3.2,
    rows: 1,
    speed: 2000,
    autoplay: false,
    autoplaySpeed: 2000,
    easing: "linear",
    cssEase: "linear",
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: linkedinProfiles?.length === 1 ? 1 : 2.2,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  useEffect(() => {
    if (linkedinProfiles?.length === 1) {
      setActiveIndex(0);
    } else {
      setActiveIndex(-1);
    }
  }, [linkedinProfiles]);

  useEffect(() => {
    if (newLinkedinUrl?.[newLinkedinUrl?.length - 1] === "/") {
      const index = linkedinProfiles?.findIndex(
        (item) => item?.linkedin_profile_url === newLinkedinUrl.slice(0, -1),
      );
      setActiveIndex(index);
    } else {
      console.log("run");
      const index = linkedinProfiles?.findIndex(
        (item) => item?.linkedin_profile_url === newLinkedinUrl,
      );
      setActiveIndex(index);
    }
  }, [linkedinProfiles, newLinkedinUrl]);

  function submit() {
    Mixpanel.track(
      Constants.Mixpanel
        .CERTIFICATE_VERIFICATION_OWNER_PAGE_CV_AND_LINKEDIN_SUBMIT_BUTTON_CLICKED,
    );
    setIsLoading(true);
    dispatch(
      updateLinkedin(
        userDetails?.email,
        newLinkedinUrl?.length > 0
          ? newLinkedinUrl
          : linkedinProfiles[activeIndex]?.linkedin_profile_url,
        (successObj) => {
          dispatch({
            type: SET_USER_LINKEDIN_URL,
            payload:
              newLinkedinUrl?.length > 0
                ? newLinkedinUrl
                : linkedinProfiles[activeIndex]?.["linkedin_profile_url"],
          });
          setIsLoading(false);
          toast.success("Profile data updated successfully");
          dispatch({
            type: SET_USER_LINKEDIN_URL,
            payload:
              newLinkedinUrl?.length > 0
                ? newLinkedinUrl
                : linkedinProfiles[activeIndex]?.["linkedin_profile_url"],
          });
        },
        (errorObj) => {},
      ),
    );
  }
  console.log("newlink", newLinkedinUrl, activeIndex);
  return (
    <div className="flex w-full flex-col items-start justify-start rounded-lg bg-[#18345A] p-3">
      <div className="w-full text-[14px] font-normal text-white md:text-[16px]">
        {linkedinProfiles?.length === 1
          ? "Confirm your LinkedIn from suggestion"
          : "Select your LinkedIn from suggestions"}
      </div>
      <div className="mt-3 w-full">
        {linkedinProfiles?.length === 0 ? (
          <div className="flex w-full justify-center">
            <FidgetSpinner />
          </div>
        ) : (
          <Slider {...settings}>
            {linkedinProfiles?.map((item, idx) => (
              <div
                className=""
                onClick={(e) => {
                  Mixpanel.track(
                    Constants.Mixpanel
                      .CERTIFICATE_VERIFICATION_OWNER_PAGE_LINKEDIN_PROFILE_SELECTED,
                  );
                  if (newLinkedinUrl?.length === 0) {
                    setActiveIndex(idx);
                  }
                }}
              >
                <div
                  className={`mx-[2px] rounded-lg bg-[#4285F4]/10 ${
                    linkedinProfiles?.length === 1 ? "h-[118px]" : "h-[140px]"
                  } ${activeIndex === idx && "border-[1px] border-[#7FC241]"}`}
                >
                  <div
                    className="relative h-[40px] w-full rounded-t-lg"
                    style={{
                      background:
                        "linear-gradient(to right, rgba(66, 133, 244, 1) 0%, rgba(112, 174, 255, 1) 100%)",
                    }}
                  >
                    {item?.profile_image ? (
                      <img
                        className={`absolute top-4 ${
                          linkedinProfiles?.length === 1
                            ? window.innerWidth > 768
                              ? "left-[45%]"
                              : "left-[42%]"
                            : window.innerWidth > 768
                            ? "left-[40%]"
                            : "left-[38%]"
                        }  h-[40px] w-[40px] self-center rounded-full`}
                        alt=""
                        src={item?.profile_image}
                      ></img>
                    ) : (
                      <FontAwesomeIcon
                        className={`absolute top-4 ${
                          linkedinProfiles?.length === 1
                            ? window.innerWidth > 768
                              ? "left-[45%]"
                              : "left-[42%]"
                            : window.innerWidth > 768
                            ? "left-[40%]"
                            : "left-[38%]"
                        }  h-[40px] w-[40px] self-center rounded-full text-white`}
                        icon={faUserCircle}
                      />
                    )}
                    {activeIndex === idx && (
                      <img
                        className="absolute right-2 top-2 h-[20px] w-[20px]"
                        alt=""
                        src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/hugeicons_checkmark-circle-03.png?updatedAt=1750670812699"
                      ></img>
                    )}
                  </div>
                  <div className="mt-6 flex items-center justify-center gap-1">
                    <div className="text-[14px] font-semibold text-white md:text-[16px]">
                      {item?.name}
                    </div>
                    {linkedinProfiles?.length === 1 && (
                      <div className="h-[16px] w-[1px] bg-white/30" />
                    )}
                    {linkedinProfiles?.length === 1 && (
                      <img
                        src="https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                        alt=""
                        className="h-[16px] w-[16px]"
                      />
                    )}
                  </div>
                  <div className="mt-[6px] px-2 text-center text-[12px] leading-[140%] text-white/70 line-clamp-2 md:text-[14px]">
                    {item?.current_designation} at {item?.current_company}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>

      <div className="mt-3 w-full text-center text-[14px] font-medium text-white">
        Or
      </div>
      <input
        type="text"
        name="role"
        value={newLinkedinUrl}
        onChange={(e) => {
          setNewLinkedinUrl(e?.target?.value);
        }}
        placeholder="Enter your LinkedIn Profile URL"
        className="mt-2 w-full rounded-lg border-none bg-[#4285F426] py-[10px] px-4 text-white outline-none placeholder:text-[14px] placeholder:text-white/30 md:text-[16px]"
      />
      <button
        className="mt-4 rounded-lg bg-[#7FC241] px-8 py-2 text-[16px] font-medium text-[#121212] disabled:opacity-50 md:text-[18px]"
        type="submit"
        disabled={
          activeIndex === -1 &&
          newLinkedinUrl?.length === 0 &&
          isLoading === false
        }
        onClick={submit}
      >
        Submit
      </button>
    </div>
  );
};

export default LinkedInSuggestions;
